module.exports = __webpack_public_path__ + "img/biaoqian_xiaofangjigou.314529ad.png";